export const BUDGET_TYPE_CAMPAIGN_DAILY_BUDGET = "CAMPAIGN_DAILY_BUDGET";
export const BUDGET_TYPE_CAMPAIGN_TOTAL_BUDGET_FOR_PERIOD = "CAMPAIGN_TOTAL_BUDGET_FOR_PERIOD";
export const BUDGET_TYPE_ADSETS_DAILY_BUDGET = "ADSETS_DAILY_BUDGET";
export const BUDGET_TYPE_ADSETS_TOTAL_BUDGET_FOR_PERIOD = "ADSETS_TOTAL_BUDGET_FOR_PERIOD";
export const BUDGET_TYPE_ADSETS_TOTAL_AND_DAILY_BUDGET_FOR_PERIOD = "ADSETS_TOTAL_AND_DAILY_BUDGET_FOR_PERIOD";
export const BUDGET_TYPE_CAMPAIGN_TOTAL_FOR_ADGROUPS_PERIODS = "CAMPAIGN_TOTAL_FOR_ADGROUPS_PERIODS";

// El título va como clave de i18n, no como literal: es lo primero que se lee de cada fila del modal
// de presupuestos y en inglés salía en español.
export const DATA_BY_BUDGET_TYPE = {
    [BUDGET_TYPE_CAMPAIGN_DAILY_BUDGET]: {
        "title_key": "ad_account_budget.type_campaign_daily",
        "has_period": false,
        "has_adset_detail": false
    },
    [BUDGET_TYPE_CAMPAIGN_TOTAL_BUDGET_FOR_PERIOD]: {
        "title_key": "ad_account_budget.type_campaign_total_for_period",
        "has_period": true,
        "has_adset_detail": false
    },
    [BUDGET_TYPE_ADSETS_DAILY_BUDGET]: {
        "title_key": "ad_account_budget.type_adsets_daily",
        "has_period": false,
        "has_adset_detail": true
    },
    [BUDGET_TYPE_ADSETS_TOTAL_BUDGET_FOR_PERIOD]: {
        "title_key": "ad_account_budget.type_adsets_total_for_period",
        "has_period": true,
        "has_adset_detail": true
    },
    [BUDGET_TYPE_ADSETS_TOTAL_AND_DAILY_BUDGET_FOR_PERIOD]: {
        "title_key": "ad_account_budget.type_adsets_total_and_daily_for_period",
        "has_period": true,
        "has_adset_detail": true
    },
    [BUDGET_TYPE_CAMPAIGN_TOTAL_FOR_ADGROUPS_PERIODS]: {
        "title_key": "ad_account_budget.type_campaign_total_for_adgroups_periods",
        "has_period": true,
        "has_adset_detail": true
    },

};
